/* global axios */
import ApiClient from './ApiClient';

class WhatsappCallHistoryAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(contactId, params = {}) {
    return axios.get(`${this.url}/${contactId}/whatsapp_calls`, { params });
  }

  getRecording(recordingUrl) {
    const requestUrl = recordingUrl.startsWith('/')
      ? recordingUrl
      : `${this.baseUrl()}/${recordingUrl}`;
    return axios.get(requestUrl, { responseType: 'blob' });
  }
}

export default new WhatsappCallHistoryAPI();
